import { render, staticRenderFns } from "./CommentsPanel.vue?vue&type=template&id=eb9323a6&scoped=true&"
import script from "./CommentsPanel.vue?vue&type=script&lang=js&"
export * from "./CommentsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommentsPanel.vue?vue&type=style&index=0&id=eb9323a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9323a6",
  null
  
)

export default component.exports